module.exports = __webpack_public_path__ + "static/media/Icon_SaveProject.fb24394b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_SaveProject.svg
// module id = 2309
// module chunks = 0